export enum RequestStatus  {
  LOADING = 'loading',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export enum METHOD {
  GET = 'get',
  POST = 'post',
  SET = 'set',
  MERGE = 'merge',
  DELETE = 'delete',
}
